import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { combineReducers } from "redux";

import AlertReducer from "./Alerts/reducer";
import AuthReducer from "./Auth/reducer";
import UserReducer from "./Users/reducer";
import RoleReducer from "./Roles/reducer";
import ItemReducer from "./Items/reducer";
import usePreventReducer from "./usePrevent/reducer";
import CareHomeGroupsReducer from "./CareHomeGroups/reducer";
import HomesReducer from "./Homes/reducer";
import EnquiriesReducer from "./Enquiries/reducer";
import NewsReducer from "./News/reducer";
import FaqsReducer from "./Faqs/reducer";
import HomeGroupAdminReducer from "./HomeGroupsAdmin/reducer";
import PagesReducer from "./Pages/reducer";
import SlickCareProfilesReducer from "./SlickCareProfiles/reducer";
import HomeGroupStaffReducer from "./HomeGroupsStaff/reducer";
import BlogsReducer from "./Blogs/reducer";
import ResidenceReducer from "./Residence/reducer";
import WebsiteReducer from "./Website/reducer";
import TOCReducer from "./TypesOfCare/reducer";
import RoomReducer from "./Rooms/reducer";
import SettingsReducer from "./EmailSettings/reducer";
import LocationBlogsReducer from "./LocationBlogs/reducer";
import ReviewsReducer from "./Reviews/reducer";
import ContactReducer from "./Contacts/reducer";
import ReviewSettingsReducer from "./ReviewSetting/reducer";
import PackageReducer from "./Package/reducer";
import HistoryReducer from "./History/reducer";
import FilterReducer from "./Filter/reducer";
import PrintReducer from "./Print/reducer";
import NetworkReducer from "./Networking/reducer";
import TaskReducer from "./Task/reducer";
import SurveyReducer from "./Survey/reducer";
import BundlesReducer from "./Bundles/reducer";
//
import RosterReducer from "./Roster/reducer";
import RosterRoleReducer from "./EmployeeRole/reducer";
import EmployeeReducer from "./Employee/reducer";
import LeaveReducer from "./EmployeeLeave/reducer";
import ShiftReducer from "./EmployeeShifts/reducer";
import RotaReducer from "./EmployeeRota/reducer";
import BudgetReducer from "./Budget/reducer";
import SheetReducer from "./Timesheet/reducer";
import WebsiteEnquiriesReducer from "./WebsiteEnquiries/reducer";
import HubBlogReducer from "./HubBlog/reducer";
import DiscrepancyReducer from "./Discrepancy/reducer";
import AvailabilityReducer from "./Availability/reducer";
import TerminalReducer from "./Terminals/reducer";
import NotificationReducer from "./Notification/reducer";
import TeamReducer from "./Teams/reducer";
import FeedReducer from "./Feed/reducer";
import FeedActionReducer from "./FeedAction/reducer";
import CommentReducer from "./FeedComments/reducer";
import FolderReducer from "./Folder/reducer";
import ModalReducer from "./Modal/reducer";
import FolderActionReducer from "./FolderAction/reducer";
import FolderContentReducer from "./FolderContent/reducer";
import TemplateReducer from "./Templates/reducer";
import StepReducer from "./Step/reducer";
import FieldReducer from "./Field/reducer";
import OnboardingReducer from "./Onboarding/reducer";
import EmployeeOnboardReducer from "./EmployeeOnboard/reducer";
import EmployeeEditReducer from "./EmployeeEdit/reducer";
import OnboardingRevisionReducer from "./OnboardingRevision/reducer";
import RotaFiltersReducer from "./RotaFilters/reducer";
import AISliceReducer from "./AISlice/reducer";
import FeedVotesReducer from "./FeedVotes/reducer";
import StatsReducer from "./Stats/reducer";
import VisitorReducer from "./Visitors/reducer";
import VisitorGateReducer from "./VisitorGate/reducer";
import ResidentReducer from "./Resident/reducer";
import PreReducer from "./ResidentPre/reducer";
import ResidentPreAssessReducer from "./ResidentPreAssess/reducer";
import ResidentNetworkReducer from "./ResidentNetwork/reducer";
import ResidentAssessmentTemplateReducer from "./ResidentAssessmentTemplate/reducer";
import HourlyRateReducer from "./HourlyRate/reducer";
import ResidentToolsReducer from "./ResidentTools/reducer";
import ResidentGovernanceReducer from "./ResidentGovernance/reducer";
import ResidentAssessmentReducer from "./ResidentAssessment/reducer";
import ResidentBodyMapReducer from "./ResidentBodyMap/reducer";
import ResidentWarningsReducer from "./ResidentWarnings/reducer";
import ResidentMedicationReducer from "./ResidentMedication/reducer";
import ResidentAppointmentReducer from "./ResidentAppointment/reducer";
import ResidentEvaluationReducer from "./ResidentEvaluation/reducer";
import SearchReducer from "./Search/reducer";
import ResidentDocumentsReducer from "./ResidentDocuments/reducer";
import OnboardingBuilderReducer from "./OnboardingBuilder/reducer";
import ResidentVaccinationReducer from "./ResidentVaccination/reducer";
import MaintenanceReducer from "./Maintenance/reducer";
import ObservationScheduleReducer from "./ObservationSchedule/reducer";
import ResidentSummaryReducer from "./ResidentSummary/reducer";
import LocationRuleReducer from "./LocationRule/reducer";
const authPersistConfig = {
  key: "AuthReducer",
  storage: storage,
  blacklist: [],
};

const profilePersistConfig = {
  key: "SlickCareProfilesReducer",
  storage: storage,
  blacklist: [],
};

const rootReducer = combineReducers({
  AuthReducer: persistReducer(authPersistConfig, AuthReducer),
  UserReducer,
  RoleReducer,
  ItemReducer,
  usePreventReducer,
  AlertReducer,
  CareHomeGroupsReducer,
  HomesReducer,
  EnquiriesReducer,
  NewsReducer,
  FaqsReducer,
  HomeGroupAdminReducer,
  PagesReducer,
  SlickCareProfilesReducer: persistReducer(
    profilePersistConfig,
    SlickCareProfilesReducer,
  ),
  HomeGroupStaffReducer,
  BlogsReducer,
  ResidenceReducer,
  WebsiteReducer,
  TOCReducer,
  RoomReducer,
  SettingsReducer,
  LocationBlogsReducer,
  ReviewsReducer,
  ContactReducer,
  ReviewSettingsReducer,
  PackageReducer,
  HistoryReducer,
  FilterReducer,
  PrintReducer,
  NetworkReducer,
  TaskReducer,
  SurveyReducer,
  BundlesReducer,
  //
  RosterReducer,
  EmployeeReducer,
  RosterRoleReducer,
  LeaveReducer,
  ShiftReducer,
  RotaReducer,
  BudgetReducer,
  SheetReducer,
  WebsiteEnquiriesReducer,
  HubBlogReducer,
  DiscrepancyReducer,
  AvailabilityReducer,
  TerminalReducer,
  NotificationReducer,
  TeamReducer,
  FeedReducer,
  FeedActionReducer,
  CommentReducer,
  ModalReducer,
  FolderReducer,
  FolderActionReducer,
  FolderContentReducer,
  TemplateReducer,
  StepReducer,
  FieldReducer,
  OnboardingReducer,
  EmployeeOnboardReducer,
  EmployeeEditReducer,
  OnboardingRevisionReducer,
  RotaFiltersReducer,
  AISliceReducer,
  FeedVotesReducer,
  StatsReducer,
  VisitorReducer,
  VisitorGateReducer,
  ResidentReducer,
  PreReducer,
  ResidentPreAssessReducer,
  ResidentNetworkReducer,
  ResidentAssessmentTemplateReducer,
  HourlyRateReducer,
  ResidentToolsReducer,
  ResidentGovernanceReducer,
  ResidentAssessmentReducer,
  ResidentBodyMapReducer,
  ResidentWarningsReducer,
  ResidentMedicationReducer,
  ResidentAppointmentReducer,
  ResidentEvaluationReducer,
  SearchReducer,
  ResidentDocumentsReducer,
  OnboardingBuilderReducer,
  ResidentVaccinationReducer,
  MaintenanceReducer,
  ObservationScheduleReducer,
  ResidentSummaryReducer,
  LocationRuleReducer,
});

export default rootReducer;
